//引入依赖插件
import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import Animate from 'animate.css'


//引入路由列表
import router from './router/index.js'
//手动关联install,告知vue使用VueRouter
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(Animate)
Vue.use(MintUI)
Vue.config.productionTip = false
var initClient = function () {
  var _width = document.documentElement.clientWidth
  // window.console.log(window.location.hash)
  let hashStr = window.location.hash
  hashStr = hashStr.substring(1)
  hashStr = hashStr.split("?")
  hashStr = hashStr[0].split("/")
  let routeStr = hashStr[hashStr.length - 1] || 'home'
  var appRender = App
  window.console.log(routeStr)
  // if (_width <= 640) {
  //   appRender = H5app
  // } else {
  //   appRender = App
  // }
  setTimeout(function () {
    if (_width <= 640) {
      router.push({
        // path: "/m/" + routeStr,
        path: "/" + routeStr,
        query: {
          key: new Date().getTime()
        }
      })
    } else {
      router.push({
        path: "/" + routeStr,
        query: {
          key: new Date().getTime()
        }
      })
    }
  }, 500)
  new Vue({
    router,
    render: h => h(appRender),
  }).$mount('#app')
}
initClient()
window.onresize = function () {
  initClient()
}
